















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUtensils, faTrash, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import CouponModal from '@/components/CouponModal/CouponModal.vue'
import constants from '@/utils/constants'
import api from '@/api'

library.add(faUtensils, faTrash, faSave, faTimes);

@Component({
  components: {
    CouponModal,
  },
})
export default class CouponPopup extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop() data!: any;

  $swal: any;
  fetchingCoupons: boolean = false;
  coupon: any = {};
  coupons: Array<any> = [];

  get updateOrderDetail() {
    return this.$store.getters.GetUpdateOrderDetail;
  }

  @Watch('updateOrderDetail.isSuccess')
  watchOrderDetailSuccess() {
    if (this.updateOrderDetail.isSuccess) {
      const payload: any = {
        orderId: this.data.orderId,
        promoId: this.coupon.id,
        discountName: this.coupon.name,
      };
      this.$store.commit('UPDATE_ORDER_DETAIL', payload);
      this.$emit('call-back', payload);
      this.$swal(
        constants.SUCCESS_MESSAGE,
        'Order Updated',
        constants.STATUS_SUCCESS
      );
    }
  }

  @Watch('updateOrderDetail.error')
  watchOrderDetailError() {
    if (this.updateOrderDetail.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderDetail.error,
        constants.STATUS_ERROR
      );
    }
  }

  getCoupons() {
    this.fetchingCoupons = true;
    api
      .GetCouponList(
        this.data.outletCode,
        'POS',
        this.data.phoneNumber
      )
      .then((res: any) => {
        if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
          this.coupons = res.data.data.result
        } else {
          this.coupons = []
        }
      })
      .catch(() => {
        this.coupons = []
      })
      .finally(() => {
        this.fetchingCoupons = false
      })
  }

  setCouponHandle(item) {
    this.coupon = item;
  }

  hideCouponHandle() {
    this.$emit('discard-modal');
  }

  saveData() {
    if (this.updateOrderDetail.isUpdating || !this.coupon.id) return;
    this.$store.dispatch('UpdateOrderDetail', {
      orderId: this.data.orderId,
      promoId: this.coupon.id,
    });
  }

  mounted() {
    this.getCoupons();
  }
}
